import { render } from "./NoticePanel.vue?vue&type=template&id=eadfe76c&scoped=true"
import script from "./NoticePanel.vue?vue&type=script&lang=js"
export * from "./NoticePanel.vue?vue&type=script&lang=js"

import "./NoticePanel.vue?vue&type=style&index=0&id=eadfe76c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eadfe76c"]])

export default __exports__